import $ from 'jquery';
// import { cacheResponseHelper } from './helpers';
import { ARCGIS_ENDPOINT_URL } from './constants';

export const createArcGISToken = async () => {
const { REACT_APP_ARCGIS_USERNAME, REACT_APP_ARCGIS_PWD } = process.env;

  const referer = window.location.origin;
  const client = 'referer';
  const expiration = 60 * 60;
  const data = {
    username: REACT_APP_ARCGIS_USERNAME,
    password: REACT_APP_ARCGIS_PWD,
    client,
    referer,
    expiration,
  };

  let token = '';
  await $.ajax({
    url: `${ARCGIS_ENDPOINT_URL}/arcgis/tokens/`,
    method: 'POST',
    data,
    success: (t) => { token = t; },
    error: (error) => { console.error(error); },
  });
  return token;
};

export function handleGISObjectLlink({ vcViewFile = '', objectId = '' }) {
  if (!vcViewFile || !objectId) {
    return '';
  }
  switch (vcViewFile) {
    case '/fiber/fiberbackbonesplice.php':
    case '/fiber/splicing.php':
    case '/fiber/mstSplicing.php':
    case '/fiber/construction.php':
      return `https://socket.maps.arcgis.com/apps/webappviewer/index.html?id=188a7f19f7754090be0e8d8961c095bd&query=190c623db44-layer-45%2COBJECTID%2C${objectId}`;
    case '/fiber/connectorizedinstall.php':
      return `https://socket.maps.arcgis.com/apps/webappviewer/index.html?id=188a7f19f7754090be0e8d8961c095bd&query=190c623db44-layer-44%2COBJECTID%2C${objectId}`;
    default:
      return '';
  }
}
